var exports = {
  "XM": "toaster-ck5Ue",
  "oR": "toast-ck5Ue",
  "VN": "close-ck5Ue",
  "Kk": "icon-ck5Ue",
};

module.exports = exports;
